import "../style.css";
import { Link } from "react-router-dom";
import logo from "../../assets/لوگو 4.svg";
import logoMobile from "../../assets/logoa2.png";
const Headers = () => {
  return (
    <div className="text-center w-100">
      <div className="hedar-box  d-none d-lg-flex justify-content-between">
        <Link className="navbar-brand text-end" href="#">
          <img src={logo} alt="Bootstrap" width="50" height="50" />
        </Link>
        <div className="">
          <nav className="navbar sticky-bottom navbar-expand-lg ">
            <div className="container-fluid">
              <button
                className="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarNav"
                aria-controls="navbarNav"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>
              <div className="collapse navbar-collapse" id="navbarNav">
                <ul className="navbar-nav ">
                  <li className="nav-item">
                    <Link
                      to="/"
                      className="nav-link active me-3 me-xl-5"
                      aria-current="page"
                    >
                      صفحه اصلی
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link active  me-3 me-xl-5" to='/aboutus'>درباره ما</Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link active  me-3 me-xl-5" to='/terms'>قوانین ومقررات</Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link active  me-3 me-xl-5" to='/toturial'>اموزش</Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link active  me-3 me-xl-5" to='/contact'>ارتباط با ما</Link>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </div>
        <Link className="navbar-brand text-end" to="/expertlogin">
          <button
            type="button"
            className="btn btn-outline-dark ps-4 pe-4 border-2"
            style={{ borderRadius: "30px" }}
          >
            ورود
          </button>
        </Link>
      </div>
      <div className=" d-lg-none ">
        <nav className="navbar  hedar-box-mobile">
          <div className="container-fluid ">
            <Link className="navbar-brand" href="#">
              <img src={logo} alt="Bootstrap" width="50" height="50" />
            </Link>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasNavbar"
              aria-controls="offcanvasNavbar"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div
              className="offcanvas offcanvas-start menu-mobile"
              tabIndex="-1"
              id="offcanvasNavbar"
              aria-labelledby="offcanvasNavbarLabel"
            >
              <div className="offcanvas-header">
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="offcanvas"
                  aria-label="Close"
                  style={{backgroundColor:"#fff"}}
                ></button>
              </div>
              <div className="offcanvas-body ">
                <ul className="navbar-nav justify-content-end flex-grow-1 pe-3">
                <li className="nav-item">
                <img alt="" src={logoMobile} className="mobile-menu-logo" />
              </li>
                  <li className="nav-item">
                    <Link className="nav-link active mobile-menu-item" aria-current="page" to='/' >
                      صفحه اصلی
                    </Link>
                  </li>
                  <li className="nav-item">
                  <Link className="nav-link active mobile-menu-item" to='/aboutus' aria-current="page"  >
                    درباره ما
                  </Link>
                </li>
                  <li className="nav-item">
                  <Link className="nav-link active mobile-menu-item" to='/terms' aria-current="page"  >
                    قوانین ومقررات
                  </Link>
                </li>
                <li className="nav-item">
                <Link className="nav-link active mobile-menu-item" to='/toturial' aria-current="page"  >
                  آموزش
                </Link>
              </li>
              <li className="nav-item">
              <Link className="nav-link active mobile-menu-item" to='/contact' aria-current="page"  >
                ارتباط با ما
              </Link>
            </li>
            <Link to='/expertlogin'>
            <div className="expert-login-btn-box" style={{width:"150px"}}>
              <button className="btn expert-login-btn text-nowrap">ورود</button>
            </div>
            </Link>
                </ul>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Headers;
